import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getPetitionActionsPageData } from './api';
import type { PetitionActionsPageDataErrorCode } from './types';

/** @knip-ignore */
export const {
	Context: PetitionActionsPageDataContext,
	Provider: PetitionActionsPageDataContextProvider,
	useContext: usePetitionActionsPageData,
	useAsyncData: usePetitionActionsPageDataFromApi,
	prefetchAsyncData: prefetchPetitionActionsPageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'PetitionActionsPageDataContext',
	dataProperty: 'pageData',
	getData: getPetitionActionsPageData,
	hasUserData: true,
	getUniqueId: (slug) => slug,
	errorHandler: pageDataErrorHandler<PetitionActionsPageDataErrorCode>(),
});

/** @knip-ignore */
export type PetitionActionsPageData = Awaited<ReturnType<typeof getPetitionActionsPageData>>;
